<template>
<v-container fluid>
  <div>
  <v-card>
    <v-col cols="12" sm="6" md="4">
    Rake on Platform Report
    </v-col>
    <v-card-title>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="400px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="pf_date" required :rules="dateRules" prepend-icon="event" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="pf_date" no-title @input="initialize()"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field v-model="stn_code" label="Stn Code" ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-btn color="primary" @click="initialize()">
            <v-icon left dark>mdi-refresh</v-icon>Refresh
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>

      </v-row>
    </v-card-title>
    <v-data-table :headers="headers" :items="trains" :search="search" item-key="pf_date+ train_no+name" :footer-props="{
    'items-per-page-options': [10, 20, 30, 40, 50, 100,900]
    }" :items-per-page="40" sort-by="pf" class="elevation-1"
     :loading="isLoading" loading-text="Loading... Please wait" :mobile-breakpoint="100">
     <!-- <template v-slot:item.id="{ item }">
       {{trains.map(function(x) {
     return x.id;
     }).indexOf(item.id)+1}}
     </template> -->
     <template v-slot:item.insert_time="{ item }">
       {{getFormattedDateTime(item.insert_time)}}
     </template>
      <template v-slot:item.update_time="{ item }">
        {{getFormattedDateTime(item.update_time)}}
      </template>
      <!-- <template v-slot:item.arr="{ item }">
        {{getFormattedTime(item.arr)}}
      </template> -->
      <template v-slot:item.action="{ item }">
        <v-btn v-if="item.device_id" text icon color="green" dark @click.native.stop="onRowClick(item)">
          <v-icon dark>mdi-information</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize()">No Report, click to retry</v-btn>
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize()">No Report, click to retry</v-btn>
      </template>
    </v-data-table>
  </v-card>
</div>

</v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'
import MaskedInput from 'vue-masked-input'
export default {
  name: 'platformdtl',
  components: {
    MaskedInput
  },
  data() {
    return {
      stn_code: 'SDAH',
      search: '',
      valid: false,
      dateRules: [v => !!v || 'Date is required'],
      trainNoRules: [v => !!v || 'Train No is required'],
      dateFormatted: moment().format('DD/MM/YYYY'),
      addRakeDialog: false,
      devices: [],
      device: {
        name: '',
        id: 0
      },
      editedIndex: -1,
      editedItem: {
        pf_date: moment().format('YYYY-MM-DD'),
        train_no:'',
        train_no_text:'',
        org: '',
        dep: '',
        dest: '',
        arr: '',
        pf: '',
        next_train_no: ''
      },
      errors: [],
      headers: [
        {
          text: 'PF No',
          value: 'pf'
        },
        {
          text: 'Rake No',
          value: 'rake_no'
        },
        {
          text: 'arr time',
          value: 'insert_time'
        },
        {
          text: 'dep Time',
          value: 'update_time'
        },
        {
          text: 'Actions',
          align: 'right',
          value: 'action',
          sortable: false
        },

      ],
      train: {},
      train_loading: false,
      trains: [],
      pf_date: this.curTrainDate || moment().format('YYYY-MM-DD'),
      menu1: false,
      menu2: false,
      isLoading: false,
      summary: {}
    }
  },
  computed: {
    ...mapState(['curDeviceId', 'curDeviceName', 'curTrainNo', 'curTrainDate', 'curOrg', 'curArr', 'curDest', 'curDep','curCrewId',
     'actDep', 'actArr','curStartDate','curEndDate',]),
  computedDateFormatted () {
         return this.formatDate(this.editItem.pf_date)
       },
   },

   watch: {
     dialog (val) {
       val || this.close()
     },
     editedItem (val) {
       this.dateFormatted = this.getFormattedDate(val.pf_date)
     },
  },

  created() {

    console.log(this.pf_date)
    console.log(this.curTrainDate)
    this.pf_date= this.curTrainDate || moment().format('YYYY-MM-DD'),
    this.initialize()
  },

  methods: {
    formatDate (date) {
        if (!date) return null
        return moment(date).format('DD/MM/YYYY')
      },
      parseDate (date) {
        if (!date) return null
        return moment(date, ['DD/MM/YYYY']).format('YYYY-MM-DD')
      },
    ...mapActions(['updateCurDeviceId', 'updateCurDeviceName', 'updateCurTrainNo', 'updateCurTrainDate', 'updateCurOrg', 'updateCurCrewId',
     'updateCurArr', 'updateCurDest', 'updateCurDep', 'updateActDep', 'updateActArr','updateCurStartDate','updateCurEndDate']),
    initialize() {
      this.menu1 = false
      this.updateCurTrainDate(moment(this.pf_date).format("YYYY-MM-DD"))
        console.log(this.curTrainDate)
      //      console.log(this.curDeviceId)
      this.isLoading = true
      this.trains = []
      var p = {
        pf_date: this.curTrainDate,
        stn_code: this.stn_code
      }
      console.log(p)
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/pf/pf_rake_enter`, {
          params: p
        })
        .then(response => {
          // console.log(response);
          this.trains = response.data
          this.isLoading = false
        })
        .catch(e => {
          console.log(e)
          this.isLoading = false
        })
    },
    onRowClick($event) {
      console.log($event);
    },
    editTrains(item) {
      if (item.device_id) {
        this.updateCurDeviceId(item.device_id)
        this.updateCurDeviceName(item.device_name)
        this.$router.push({
          name: 'Trains'
        })
      }
    },
    addrake(item) {
      this.getDevices()

      this.editedItem.date = this.pf_date
      this.editedItem.train_no = item.train_no
      this.editedItem.org = item.org
      this.editedItem.dest = item.dest
      this.editedItem.dep = item.dep
      this.editedItem.arr = item.arr
      this.editedIndex = this.trains.indexOf(item)
      this.addRakeDialog = true
    },
    close () {
      this.addRakeDialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    getDevices() {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/device/device_list`)
        .then(response => {
          // console.log(response);
          this.devices=[]
          this.devices = response.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    save() {
       var dep = moment(this.editedItem.pf_date).format("YYYY-MM-DD") + ' ' + this.editedItem.dep
       var arr = moment(this.editedItem.pf_date).format("YYYY-MM-DD") + ' ' + this.editedItem.arr
       if (moment(dep) > moment(arr)) {
         arr = moment(arr).add(1, 'days').format("YYYY-MM-DD HH:mm:ss")
       }
       var update_time = moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss')
       console.log(dep, arr)
       var train_device_map = {
         pf_date: moment(this.editedItem.pf_date).format("YYYY-MM-DD"),
         train_no: this.editedItem.train_no,
         device_id: this.device.id,
         device_name: this.device.name,
         unique_device_id: this.device.id,
         org: this.editedItem.org,
         dep: dep,
         dest: this.editedItem.dest,
         arr: arr ,
         pf: this.editedItem.pf,
         next_train_no: this.editedItem.next_train_no,
         insert_time: update_time,
         update_time: update_time,
       }

        console.log(train_device_map)
         axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

         axios.post(`${process.env.VUE_APP_API_URL}/train/`, train_device_map)
         .then(response => {
           console.log(this.trains[this.editedIndex])
           this.trains[this.editedIndex].device_name = this.device.name
           this.trains[this.editedIndex].device_id = this.device.id
          // this.trains.push(this.editedItem)
          // this.trains.unshift(train_device_map)
          // alert("Registered successfully")
           })
         .catch(e => {
           console.log(e)
         })
       this.close()
    },
    queryTrain($event) {
          axios.get(`${process.env.VUE_APP_API_URL}/timetable/${$event}`)
          .then(response => {
            console.log(response);
            if ( response.data[0]) {
              this.valid = true
              this.editedItem.org = response.data[0].org
              this.editedItem.dep = response.data[0].dep
              this.editedItem.dest = response.data[0].dest
              this.editedItem.arr = response.data[0].arr
              this.editedItem.pf = response.data[0].pf
              this.editedItem.next_train_no = response.data[0].next_train_no
            } else {
              // this.valid =false
              this.editedItem.org = null
              this.editedItem.dep = null
              this.editedItem.dest = null
              this.editedItem.arr = null
              this.editedItem.pf = null
              this.editedItem.next_train_no = null
            }
          })
          .catch(e => {
            this.errors.push(e)
          })
        },

    getFormattedDate(t) {
      if (t) {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
        var testDateUtc = moment.utc(lt);
        var localDate = moment(testDateUtc).local();
        return localDate.format("DD/MM/YYYY")
      } else {
        return '--'
      }
    },
    getFormattedTime(t) {
      if (t !== '--') {
       //  var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
       //  var testDateUtc = moment.utc(lt);
       // var localDate = moment(testDateUtc).local();
       //  return moment(localDate).format("HH:mm:ss")
       return moment.utc(t).format("HH:mm:ss")
      }
    },
    getFormattedDateTime(t) {
      if (t != null) {
       //  var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
       //  var testDateUtc = moment.utc(lt);
       // var localDate = moment(testDateUtc).local();
       //  return moment(localDate).format("HH:mm:ss")
       return moment.utc(t).format("DD/MM/YYYY HH:mm:ss")
      }
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return '-' + moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      } else {
        return moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      }
    },

    getColour(train) {
      if (train.act_arr) {
        let x = train.late_arr / 60
        switch (true) {
          case (x < 1):
            return 'green'
            break;
          case (x < 5):
            return '#6B8E23'
            break;
          case (x < 11):
            return 'blue'
            break;
          case (x < 21):
            return 'orange'
            break;
          case (x < 31):
            return '#FF1493'
            break;
          case (x < 1000):
            return 'red'
            break;
          default:
            return '#F5DEB3'
            break;
        }
      }
    },
    getSummaryColour(s) {
      return s == "more than 30" ? 'red' :
        s == "21 to 30" ? '#FF1493' :
        s == "11 to 20" ? 'orange' :
        s == "5 to 10" ? 'blue' :
        s == "less than 5" ? '#6B8E23' :
        s == "Right Time" ? 'green' :
        s == "total late" ? '#A52A2A' :
        s == "total train" ? '#D2691E' :
        s == "Puctuality" ? '#8A2BE2' :
        '#F5DEB3'
    },
    getSummary(trains) {
      let summary = {
        "Right Time": 0,
        "less than 5": 0,
        "5 to 10": 0,
        "11 to 20": 0,
        "21 to 30": 0,
        "more than 30": 0,
        "total late": 0,
        "total train": 0,
        "Puctuality": 0
      }
      _.forEach(trains, (train) => {
        if (train.act_arr) {
          let x = train.late_arr / 60
          switch (true) {
            case (x < 1):
              summary["Right Time"]++;
              summary["total train"]++;
              break;
            case (x < 5):
              summary["less than 5"]++;
              summary["Right Time"]++;
              summary["total train"]++;
              break;
            case (x < 11):
              summary["5 to 10"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 21):
              summary["11 to 20"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 31):
              summary["21 to 30"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 1000):
              summary["more than 30"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            default:
              break;
          }
        }
      })
      summary["Puctuality"] = Math.round((summary["Right Time"] / summary["total train"]) * 100, 2)
      return summary
    }
  }
}
</script>
